/* eslint-disable react/no-array-index-key */
import {Box} from '@chakra-ui/react';
import {motion} from 'framer-motion';

export const ScrollDownIndicator: React.FC = () => {
  return (
    <Box display="inline-block">
      {[1, 2, 3].map((_, index) => {
        return (
          <Box h="20px">
            <svg
              key={`svg-${index}`}
              xmlns="http://www.w3.org/2000/svg"
              width="50"
              height="28"
              fill="none"
            >
              <motion.path
                stroke={index % 2 ? '#153041' : '#71818c'}
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="4.5"
                d="m3 3 22 22L47 3"
                animate={{
                  scale: [0.9, 1, 0.9],
                  stroke: ['#71818c', '#153041', '#71818c'],
                }}
                transition={{
                  repeat: Infinity,
                  duration: 0.7,
                  delay: index * 0.35,
                  repeatDelay: 1,
                }}
              />
            </svg>
          </Box>
        );
      })}
    </Box>
  );
};
